import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DashboardService} from "../../lib/services/dashboard/dashboard.service";
import {SingleContract} from "../../lib/models/contracts";
import {StorageKeysEnum} from "../../lib/storage/storage-keys.enum";
import * as pubsub from 'pubsub-js'
import {UserInfo} from "../../lib/models/user-info.model";
import {UserUtilsService} from "../../lib/services/user/user-utils.service";
import {Router} from "@angular/router";
import {ContractsUtils} from "../../lib/user/contracts/contracts.utils";
import {command} from "../../layout/sidebar/menu";
export const BASELINK = '/nueva-banca-digital'

@Component({
  selector: 'app-pending-payments-authorizations-modal',
  templateUrl: './pending-authorizations-list-modal.component.html',
  styleUrls: ['./pending-authorizations-list-modal.component.scss']
})
export class PendingAuthorizationsListModalComponent implements OnInit{

  @Output() closeModalEvent: EventEmitter<boolean> = new EventEmitter<boolean>()
  @Input() showModal: boolean = false;
  @Input() modalData:any
  @Output() setNotificationRead: EventEmitter<any> = new EventEmitter();
  contracts: SingleContract[] = [];
  contractsPendingPayments: any[] = [];
  allContracts: UserInfo[] = [];
  contractSelected!: UserInfo | undefined;
  @Output() notifyCloseNotificationDialog = new EventEmitter<any>()
  pendingTitle: string = ""

  constructor(
      private router : Router,
      private dashboardService: DashboardService,
      private userUtilsService: UserUtilsService,
      private contractUtils: ContractsUtils,
  ) {
    this.allContracts = this.contractUtils.getContractsByServices()
    this.contracts = dashboardService.getContracts().contracts
  }

  ngOnInit(

  ) {
    this.contractsPendingPayments = this.getContratsPendingPayments();
    this.getPendingTitle(this.modalData?.tipoNotificacion)

  }
  getContratsPendingPayments(){
    const idsFiltro = this.modalData?.contenido.contratos.map(dato => dato.refNumContrato)
    return this.contracts.filter(item => idsFiltro.includes(item.idReferenceContract))
  }
  closePendingPaymentModal() {
    this.closeModalEvent.emit();
  }
  goToNotificationCenter(contractId: any) {
    if(contractId){
      //console.log("contratos: "+this.modalData?.contratos) //array de objetos
      this.setReadNotification(this.modalData.notificationId)
      this.changeContract(contractId)
      this.closePendingPaymentModal()
      this.notifyCloseNotification()
      this.redirectToModule();
    }
    this.closePendingPaymentModal()
  }
  changeContract(contractId: any) {
    const userInfo = this.userUtilsService.getUserInfoSessionStorage()
    this.contractSelected = this.allContracts.find(x => x.idContrato == contractId)
    sessionStorage.setItem(StorageKeysEnum.USER_INFO, JSON.stringify(
        {...userInfo,contrato: this.contractSelected,}));
    this.dashboardService.updateContract(this.contractSelected)
    pubsub.publish("contract", this.contractSelected)
  }
  setReadNotification(idNotification: number) {
    this.setNotificationRead.emit(idNotification)
  }
  notifyCloseNotification(){
    this.notifyCloseNotificationDialog.emit();
  }

  private redirectToModule() {
    if (this.modalData.tipoNotificacion == 'AUT_PAG') {
      command('NOTIFICATIONS', 'CMP_CARGA')
      this.router.navigate([BASELINK + `/pagos/autorizacion/single`])
    } else if (this.modalData.tipoNotificacion == 'AUT_DEST') {
      command('NOTIFICATIONS', 'CMD_CARGA')
      this.router.navigate([BASELINK + `/destinatarios/autorizacion/single`])
    }
  }

  private getPendingTitle(tipoNotificacion: any) {
    if(tipoNotificacion === 'AUT_PAG'){
      this.pendingTitle = 'Autorizacion pendiente de pagos';
    }else if(tipoNotificacion === 'AUT_DEST'){
      this.pendingTitle = 'Autorizacion pendiente de destinatarios';
    }
  }
}